import { get, post } from '../utils/request';

// 获取系统设置
export const getCode = (data: object) => get('/v2/imgcode/getcode', { ...data, _t: +new Date() });

export const verifyCode = (data: { imgcode: string, key: string }) => post('/v2/imgcode/verifycode', data);

export const emailNotice = (data?: object) => get('/v2/imgcode/emailnotice', data);

export default {
    getCode, verifyCode, emailNotice
};
